import React from 'react'

export default function Image({ src, rounded, roundedFull, className, ...attrs }) {
    return <img src={src} className={`max-w-full ${rounded ? 'rounded' : roundedFull ? 'rounded-full' : ''} ${className ? className : ''}`} {...attrs}/>
}
